/**
 * Build the playback URL for an audio_key. The base is configurable via
 * `VITE_AUDIO_BASE` so the same code targets:
 *   • dev / pre-R2:  `/audio` (Vite-served from apps/app/public/audio/)
 *   • prod:          `https://audio.fluent.ge` (R2 custom domain)
 *
 * The audio_key already includes the `.mp3` suffix per the schema.
 */
const BASE = (import.meta.env.VITE_AUDIO_BASE as string | undefined)?.replace(/\/+$/, '') ?? '/audio';

export function audioUrl(audioKey: string): string {
  return `${BASE}/${audioKey}`;
}

export const AUDIO_BASE = BASE;
